<!-- Forgot password: use token -->
<section>
    <form [formGroup]="resetTokenForm" (ngSubmit)="resetTokenSubmit()">
        <p class="lead">Your password reset token has been sent!</p>
        <p>Please enter it below. Note: the token is only valid for 60 minutes.</p>
        <mat-form-field style="width: 100%" appearance="fill">
            <mat-label>Token</mat-label>
            <input type="text" matInput formControlName="token" maxlength="6" />
            <mat-error>{{ fieldError(resetTokenForm, 'token') }}</mat-error>
        </mat-form-field>
        <div>
            <button style="width: 100%" class="mt-2 auth-form-submit" mat-flat-button type="submit">Next</button>
        </div>
        <div class="mt-4 mb-5 links">
            <a routerLink="/login/reset-password" style="color: var(--tenant-header); font-size: 1.6rem">Request New Reset Token</a>
        </div>
    </form>
</section>
